export default "__VITE_ASSET__BJBlSf3x__"